import type { ThreadApiResponse } from '@teo/widget-shared';
import {
  clearWidgetSession,
  getWidgetAuthHeaders,
  getWidgetSession,
} from '../session/widget-session.js';

const THREAD_PATH = '/api/thread';

export class WidgetThreadError extends Error {
  readonly status: number;

  constructor(status: number, message?: string) {
    super(message ?? `[Teo Widget] Thread request failed (${status})`);
    this.name = 'WidgetThreadError';
    this.status = status;
  }
}

export function buildThreadUrl(
  apiBase: string,
  threadId: number | string,
): string {
  const base = apiBase.replace(/\/$/, '');
  return `${base}${THREAD_PATH}/${threadId}`;
}

export async function fetchThread(
  threadId: number | string,
  apiBase: string,
): Promise<ThreadApiResponse> {
  const url = buildThreadUrl(apiBase, threadId);
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'omit',
    headers: {
      Accept: 'application/json',
      ...getWidgetAuthHeaders(),
    },
  });

  if (!response.ok) {
    if (response.status === 401) {
      const session = getWidgetSession();
      clearWidgetSession(session?.slug);
    }
    throw new WidgetThreadError(response.status);
  }

  return response.json() as Promise<ThreadApiResponse>;
}
